export function toggleChecked(el){
    if (el.checked){
        el.checked = false
    }else{
        el.checked = true
    }
}

export function getFormData(classSelector){
    const data = []
    $(classSelector).each(function(){
        const el = $(this)[0]
        data.push({'id': el.id, 'val': el.checked})
    })
    return data
}

export function updateFormElements(classSelector, data){
    $(classSelector).each(function(){
        const cardEl = $(this)
        let inputEl = $(cardEl.children("input"))[0]
        
        // 
        if (typeof inputEl == 'undefined'){
            // use a method to get inbput from catCard and SkCard !!
            inputEl = $(cardEl.children(".el-form-right").children("input"))[0]
        }
        const elementStored = data.filter(el => el.id == inputEl.id)[0]
        inputEl.checked = elementStored.val
        if (elementStored.val) {
            cardEl.addClass("active")
        }else{
            cardEl.removeClass("active")
        }
    })
}